import React from 'react';
import { motion } from 'framer-motion';
const fadeInUp = {
  initial: {
    opacity: 0,
    y: 24
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    margin: '-60px'
  },
  transition: {
    duration: 0.5,
    ease: 'easeOut'
  }
};
export function ProblemSection() {
  return <section className="w-full px-5 py-16 md:py-24" data-id="element-285">
      <div className="max-w-3xl mx-auto" data-id="element-286">
        <motion.h2 {...fadeInUp} className="text-2xl md:text-4xl font-semibold text-[#2C2825] mb-6 text-center" data-id="element-287">
          Por qué lo que has probado hasta ahora no funciona
        </motion.h2>

        <motion.p {...fadeInUp} transition={{
        ...fadeInUp.transition,
        delay: 0.05
      }} className="text-[#2C2825]/75 text-[15px] md:text-base leading-relaxed text-center mb-12 max-w-2xl mx-auto" data-id="element-288">
          La mayoría de productos y consejos tratan todas las ojeras como si
          fueran iguales. Pero no lo son. Existen al menos 4 tipos diferentes, y
          cada uno responde a causas distintas:
        </motion.p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-289">
          <motion.div {...fadeInUp} transition={{
          ...fadeInUp.transition,
          delay: 0.1
        }} className="bg-white rounded-xl p-6 border border-[#B8A99A]/20" data-id="element-290">
            <span className="inline-block text-xs font-semibold uppercase tracking-wider text-[#C4956A] mb-2" data-id="element-291">
              01
            </span>
            <h3 className="text-lg font-semibold text-[#2C2825] mb-2" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-292">
              Tono (azul/marrón)
            </h3>
            <p className="text-[#2C2825]/70 text-sm leading-relaxed" data-id="element-293">
              Relacionado con pigmentación o circulación. Un contorno hidratante
              no va a cambiar el color.
            </p>
          </motion.div>

          <motion.div {...fadeInUp} transition={{
          ...fadeInUp.transition,
          delay: 0.15
        }} className="bg-white rounded-xl p-6 border border-[#B8A99A]/20" data-id="element-294">
            <span className="inline-block text-xs font-semibold uppercase tracking-wider text-[#C4956A] mb-2" data-id="element-295">
              02
            </span>
            <h3 className="text-lg font-semibold text-[#2C2825] mb-2" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-296">
              Sombra (hundimiento)
            </h3>
            <p className="text-[#2C2825]/70 text-sm leading-relaxed" data-id="element-297">
              Causado por la pérdida de volumen bajo el ojo. Ningún sérum
              rellena lo que la estructura ósea ha perdido.
            </p>
          </motion.div>

          <motion.div {...fadeInUp} transition={{
          ...fadeInUp.transition,
          delay: 0.2
        }} className="bg-white rounded-xl p-6 border border-[#B8A99A]/20" data-id="element-298">
            <span className="inline-block text-xs font-semibold uppercase tracking-wider text-[#C4956A] mb-2" data-id="element-299">
              03
            </span>
            <h3 className="text-lg font-semibold text-[#2C2825] mb-2" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-300">
              Textura (deshidratación)
            </h3>
            <p className="text-[#2C2825]/70 text-sm leading-relaxed" data-id="element-301">
              Piel fina, líneas marcadas, aspecto apagado. Necesita hidratación
              profunda y protección, no solo crema.
            </p>
          </motion.div>

          <motion.div {...fadeInUp} transition={{
          ...fadeInUp.transition,
          delay: 0.25
        }} className="bg-white rounded-xl p-6 border border-[#B8A99A]/20" data-id="element-302">
            <span className="inline-block text-xs font-semibold uppercase tracking-wider text-[#C4956A] mb-2" data-id="element-303">
              04
            </span>
            <h3 className="text-lg font-semibold text-[#2C2825] mb-2" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-304">
              Bolsa (retención)
            </h3>
            <p className="text-[#2C2825]/70 text-sm leading-relaxed" data-id="element-305">
              Acumulación de líquido o grasa. Los parches fríos alivian, pero no
              resuelven la causa.
            </p>
          </motion.div>
        </div>

        <motion.p {...fadeInUp} transition={{
        ...fadeInUp.transition,
        delay: 0.3
      }} className="mt-10 text-center text-[#2C2825]/80 text-[15px] md:text-base leading-relaxed max-w-2xl mx-auto" data-id="element-306">
          Si no sabes cuál es tu tipo, estás aplicando soluciones genéricas a un
          problema específico.{' '}
          <strong className="text-[#2C2825] font-semibold" data-id="element-307">
            Y por eso no ves resultados.
          </strong>
        </motion.p>

        {/* Infographic Image */}
        <motion.div {...fadeInUp} transition={{
        ...fadeInUp.transition,
        delay: 0.35
      }} className="mt-12" data-id="element-308">
          <img src="https://cdn.magicpatterns.com/uploads/3rcGHF8NV5DSNpa7ZCvVsn/tonos-ojeras2.png" alt="Infografía: Los 4 tipos de ojeras más comunes — tono, sombra, textura y bolsa" className="w-full rounded-2xl shadow-lg shadow-[#2C2825]/6" data-id="element-309" />
        </motion.div>
      </div>
    </section>;
}